import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
// redux
import { recoveryUser } from 'redux/auth/operations';
// components
import Input from 'components/Form/Input';
// scss
import 'components/Form/Input.scss';
import 'components/forms/AuthForm/AuthForm.scss';

const RecoveryForm = () => {
  const [phoneValue, setPhoneValue] = useState('');
  const dispatch = useDispatch();

  function onChange(e) {
    setPhoneValue(e.target.value);
  }

  function onKeyPress(e) {
    const regex = /[0-9+\- ]/;

    const char = String.fromCharCode(e.charCode);
    if (!regex.test(char)) {
      e.preventDefault();
    }
  }

  function onSubmit(e) {
    e.preventDefault();

    const form = e.currentTarget;
    const data = {
      phone: form?.elements?.phone?.value,
    };

    dispatch(recoveryUser(data));
  }

  return (
    <form className="auth-form" name="recoveryForm" id="recoveryForm" onSubmit={onSubmit} >
      <label className="auth-form__label label">
        <span>Номер телефону</span>
        <Input
          className="auth-form__input"
          type="tel"
          name="phone"
          placeholder="Введіть Ваш номер телефону"
          value={phoneValue}
          onChange={onChange}
          onKeyPress={onKeyPress}
          required={true}
          minLength={10}
          maxLength={13}
        />
      </label>
      <button className="auth-form__btn-submit" type="submit"> Надіслати </button>
    </form>
  );
};

export default RecoveryForm;
